import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'
import { posts, searchResults } from '../pages/Blog/mockData'
import { setup } from 'axios-cache-adapter'
import { plans } from '../pages/Plans/mockData'
import { cartItems } from '../pages/Cart/mockData'
import { v4 as uuid } from 'uuid'
import { CartItemTypes } from '../pages/Cart/cartSlice'
import { store } from '../redux/store'
import { userSelectors } from '../redux/userSlice'
import Auth from '../util/Auth'

export const mockHelper = axios.create()

const mock = new MockAdapter(mockHelper, { delayResponse: 2000 })

mock.onGet('Blogpost', { params: { pageNo: 1 } }).reply(200, {
    data: posts,
    paging: {
        pageNo: 1,
        pageSize: 10,
        pageCount: 2,
        totalRecordCount: 5,
    },
})

mock.onGet('Blogpost', { params: { pageNo: 2 } }).reply(200, {
    data: posts,
    paging: {
        pageNo: 2,
        pageSize: 10,
        pageCount: 2,
        totalRecordCount: 5,
    },
})

posts.forEach(post => {
    mock.onGet(`Blogpost/${post.postId}`).reply(200, post)
})

mock.onGet('Subscriptionplan').reply(200, plans)

let mockCartAPIData = [...cartItems]

const cartEndpoint = /Cart\/*/
const bulkCartEndpoint = /Cart\/bulk\/*/

mock.onGet(cartEndpoint).reply(200, cartItems)

mock.onPost(bulkCartEndpoint).reply(config => {
    const newItems = []
    for (const item of config.data) {
        const { id, invites, type } = item
        const cartItemId = uuid()
        const newCartItem = {
            cartItemId,
            id,
            invites,
            type,
        }
        if (newCartItem.type === CartItemTypes.Plan)
            mockCartAPIData = mockCartAPIData.filter(
                item => item.type !== CartItemTypes.Plan
            )
        mockCartAPIData.push(newCartItem)
        newItems.push(newCartItem)
    }

    return [200, newItems]
})

mock.onDelete(bulkCartEndpoint).reply(config => {
    mockCartAPIData = mockCartAPIData.filter(
        item => !config.data.includes(item.cartItemId)
    )
    return [200]
})

mock.onPost(cartEndpoint).reply(config => {
    const { id, invites, type } = config.data
    const cartItemId = uuid()
    const newCartItem = {
        cartItemId,
        id,
        invites,
        type,
    }
    if (newCartItem.type === CartItemTypes.Plan)
        mockCartAPIData = mockCartAPIData.filter(
            item => item.type !== CartItemTypes.Plan
        )
    mockCartAPIData.push(newCartItem)
    return [200, newCartItem]
})

mock.onDelete(cartEndpoint).reply(config => {
    const { cartItemId } = config.data
    mockCartAPIData = mockCartAPIData.filter(
        item => item.cartItemId !== cartItemId
    )
    return [200]
})

mock.onPost(/Payment\/VerifyPayment\/*/).reply(200, {
    success: true,
    token: uuid(),
})

mock.onPost(/Paymentlog\/*/).reply(200, {
    success: true,
    data: {
        earnedPoints: 300,
    },
})

mock.onGet('search').reply(config => {
    const { catid, type, premium, price, sort = 'name', search } = config.params
    let response = searchResults

    if (search) {
        response = response.filter(data => RegExp(search, 'i').test(data.title))
    }

    if (catid) {
        response = response.filter(data =>
            data.catid.split(';').some(cat => cat === catid)
        )
    }

    if (type) {
        response = response.filter(data => data.type === type)
    }

    if (premium === 'true') {
        response = response.filter(
            data => data.type === 'course' && data.freeonsubcription === 0
        )
    } else if (premium === 'false') {
        response = response.filter(
            data => data.type === 'course' && data.freeonsubcription === 1
        )
    }

    if (price) {
        switch (price) {
            case 'lt5000': {
                response = response.filter(data => data.price < 5000)
                break
            }
            case 'gt50000': {
                response = response.filter(data => data.price >= 50000)
                break
            }
            case 'gt20000': {
                response = response.filter(data => data.price >= 20000)
                break
            }
            case 'gt10000': {
                response = response.filter(data => data.price >= 10000)
                break
            }
            case 'gt5000': {
                response = response.filter(data => data.price >= 5000)
                break
            }
            default: {
                break
            }
        }
    }

    return [200, response]
})

const trxn_regex = /\/Payment\/CheckPayment\/*/

mock.onGet(trxn_regex)
    .replyOnce(200, { status: 'pending' })
    .onGet(trxn_regex)
    .networkErrorOnce()
    .onGet(trxn_regex)
    .timeoutOnce()
    .onGet(trxn_regex)
    .replyOnce(200, { status: 'pending' })
    .onGet(trxn_regex)
    .reply(async _ => {
        const state = store.getState()
        const customer = { ...(userSelectors.userDetails(state) ?? {}) }
        customer.loyalitypoint = (customer.loyalitypoint ?? 0) + 40
        await new Promise(resolve => setTimeout(resolve, 10000))
        return [
            200,
            { success: true, status: 'successful', data: customer, error: {} },
        ]
    })

export const fetchHelper = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})

export const fetchCachedHelper = setup({
    baseURL: process.env.REACT_APP_API_URL,

    cache: {
        maxAge: 15 * 60 * 1000,
        exclude: { query: false },
    },
})

export const IMG_URL = process.env.REACT_APP_IMG_URL

//configureAuthentication configures the authentication of the app
//basically we configure authentication when the app loads, during login and register
//@todo: Its important to save token Inmemory, current impl is susceptible to xss attack
export const configureAuthentication = token => {
    let _token = token || Auth.getToken()
    fetchHelper.defaults.headers.common['Authorization'] = `Bearer ${_token}`
    fetchCachedHelper.defaults.headers.common[
        'Authorization'
    ] = `Bearer ${_token}`
    Auth.setToken(_token)
}

configureAuthentication()
